import ActivityApi from '../../apis/activity';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { isErrorWithMessage } from '../../helper';
import { resettingActivityLoader } from '../slices/activity';
import { RootState } from '../../redux/store';


export const fetchDealActivityThunk = createAsyncThunk(
    'activity/fetch',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ActivityApi.fetchDealActivities(state.app.token, state.deal.selectedDeal?.id as number);
            if (response?.success === 1) {
                return response?.activityLog;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingActivityLoader());
        }
    }
);

export const fetchAutomationActivityThunk = createAsyncThunk(
    'activity/automation',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ActivityApi.getAutomationLogs(state.app.token, state.automation.selectedAutomation?.id as number);
            if (response?.success === 1) {
                return response?.data;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingActivityLoader());
        }
    }
);

export const fetchAllActivitiesThunk = createAsyncThunk(
    'activity/fetch-all',
    async (_, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ActivityApi.fetchActivities(state.app.token);
            if (response?.success === 1) {
                return response?.activityLog;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingActivityLoader());
        }
    }
);


export const setCallLogThunk = createAsyncThunk(
    'activity/set-call',
    async ({ to, call_sid }:{to: string, call_sid: string}, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await ActivityApi.setCallLog(state.app.token, state.deal.selectedDeal?.id || 0, to, call_sid);
            if (response?.success === 1) {
                await dispatch(fetchDealActivityThunk()).unwrap();
                return true;
            }
            return errorHandler(response?.msg as string || 'Request Failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingActivityLoader());
        }
    }
);
